import React from "react";
import Dropdown from "react-bootstrap/Dropdown";

const Buttons = ({ type = "button", btnlabel, className, onClick, children }) => {
  return (
    <button type={type} className={className} onClick={onClick}>
      {children || btnlabel}
    </button>
  );
};

const ActionButton = ({
  options,
  label,
  className,
  type = "button",
  title,
  onClick,
  children,
}) => {
  if (Array.isArray(options)) {
    return (
      <Dropdown className={className}>
        <Dropdown.Toggle
          variant="light"
          className="d-flex align-items-center gap-1 border-0 bg-transparent shadow-none px-3 py-1 fw-semibold text-dark"
          style={{ color: "#1e293b" }}
        >
          {label || children}
        </Dropdown.Toggle>
        <Dropdown.Menu className="shadow-sm border-0 rounded-3 mt-1">
          {options.map((option, index) => (
            <Dropdown.Item
              key={index}
              onClick={option.onClick}
              className="d-flex align-items-center gap-2 py-2 px-3 text-dark"
            >
              {option.icon && <span className="text-primary d-inline-flex">{option.icon}</span>}
              <span>{option.label}</span>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  return (
    <button
      type={type}
      className={className}
      title={title}
      onClick={onClick}
    >
      {children || label}
    </button>
  );
};

export { Buttons, ActionButton };
